import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "facet-range-control__form" }
const _hoisted_2 = { class: "facet-range-control__price-range" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_4 = { class: "facet-range-control__range" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "facet-range-control__min-handle" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "facet-range-control__max-handle" }, null, -1)

import {
  computed, inject, ref,
  watch,
} from 'vue';

import {
  FacetHit, toggleFacetValueKey, clearFacetKey,
} from '@/composables/useDynamicProductListing';
import useContext from '@/composables/useContext';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'FacetRangeControl',
  props: {
  facet: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { channel, cart, formatPrice } = useContext();

const toggleFacetValue = inject(toggleFacetValueKey, () => null);
const clearFacet = inject(clearFacetKey, () => null);
const track = ref<any>(null);

let dragging: string | null = null;

const maxSelected = ref<number | undefined>(
  props.facet?.selectedRange?.max || props.facet.range?.max || 0,
);
const minSelected = ref<number | undefined>(
  props.facet?.selectedRange?.min || props.facet.range?.min || 0,
);
const minInput = ref<number | string>(
  Math.min(props.facet?.selectedRange?.min || Number.MAX_VALUE, props.facet.range?.min || 0),
);
const maxInput = ref<number | string>(
  Math.max(props.facet?.selectedRange?.max || Number.MIN_VALUE, props.facet.range?.max || 0),
);

const min = computed(() => Math.min(props.facet.selectedRange?.min || Number.MAX_VALUE, props.facet.range?.min || 0));
const max = computed(() => Math.max(props.facet.selectedRange?.max || Number.MIN_VALUE, props.facet.range?.max || 0));

const selectedStartPerc = computed(() => {
  const distance = max.value - min.value;
  return (((minSelected.value || min.value) - min.value) / distance) * 100;
});
const selectedEndPerc = computed(() => {
  const distance = max.value - min.value;
  return (
    100 - (((maxSelected.value || max.value) - min.value) / distance) * 100
  );
});
const trainStyle = computed(() => ({
  left: `${selectedStartPerc.value}%`,
  right: `${selectedEndPerc.value}%`,
}));
const minHandleStyle = computed(() => ({
  left: `${selectedStartPerc.value}%`,
}));
const maxHandleStyle = computed(() => ({
  right: `${selectedEndPerc.value}%`,
}));

const minInputFormatted = computed(() => formatPrice(+minInput.value, undefined, channel?.value?.locale, cart?.value.currency.id));

const maxInputFormatted = computed(() => formatPrice(+maxInput.value, undefined, channel?.value?.locale, cart?.value.currency.id));

let dragOffset = 0;

function dragStart($event, handle: string) {
  $event.preventDefault();
  $event.stopPropagation();
  window.addEventListener('mousemove', drag);
  window.addEventListener('touchmove', drag);
  window.addEventListener('mouseup', dragEnd);
  window.addEventListener('touchend', dragEnd);
  dragging = handle;

  const target = $event.target.parentElement.getBoundingClientRect();
  let clientX;
  if ($event.touches?.[0]?.clientX) {
    clientX = $event.touches[0].clientX;
  } else {
    clientX = $event.clientX;
  }
  dragOffset = clientX - target.left;
}

watch(() => props.facet, () => {
  maxSelected.value = props.facet?.selectedRange?.max || props.facet.range?.max || 0
  minSelected.value = props.facet?.selectedRange?.min || props.facet.range?.min || 0
  minInput.value = props.facet?.selectedRange?.min || props.facet.range?.min || 0
  maxInput.value = props.facet?.selectedRange?.max || props.facet.range?.max || 0
})

function dragEnd($event) {
  $event.preventDefault();
  $event.stopPropagation();
  window.removeEventListener('mousemove', drag);
  window.removeEventListener('touchmove', drag);
  window.removeEventListener('mouseup', dragEnd);
  window.removeEventListener('touchend', dragEnd);
  dragging = null;
  commitValue();
}

function drag($event) {
  let clientX;
  if ($event.touches?.[0]?.clientX) {
    clientX = $event.touches[0].clientX;
  } else {
    clientX = $event.clientX;
  }

  const train = track.value.getBoundingClientRect();
  const posPx = clientX - train.left - dragOffset;
  const pos = (posPx / train.width) * 100;

  if (dragging == 'min') {
    selectMinValue(pos);
  } else if (dragging == 'max') {
    selectMaxValue(pos);
  }
}

function selectMinValue(value) {
  if (value > 100) {
    value = 100;
  } else if (value < 0) {
    value = 0;
  }
  value = parseInt(((max.value - min.value) / 100) * value + min.value, 10);

  if (maxSelected.value && value > maxSelected.value) {
    maxSelected.value = value;
    maxInput.value = value;
  }
  if (minSelected.value == min.value) {
    minSelected.value = undefined;
  } else {
    minSelected.value = value;
  }
  minInput.value = value;
}

function selectMaxValue(value) {
  if (value > 100) {
    value = 100;
  } else if (value < 0) {
    value = 0;
  }
  value = parseInt(((max.value - min.value) / 100) * value + min.value, 10);

  if (minSelected.value && value < minSelected.value) {
    minSelected.value = value;
    minInput.value = value;
  }
  if (value == max.value) {
    maxSelected.value = undefined;
  } else {
    maxSelected.value = value;
  }
  maxInput.value = value;
}

function commitValue() {
  const bothMaxOrUndefined = (minSelected.value === undefined || minSelected.value == min.value) && (maxSelected.value === undefined || maxSelected.value == max.value);
  if (bothMaxOrUndefined) {
    console.log('clearing');
    clearFacet(props.facet as FacetHit);
  } else {
    toggleFacetValue(props.facet as FacetHit, {
      min: minSelected.value || min.value,
      max: maxSelected.value || max.value,
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "facet-name"),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(minInputFormatted)) + " ", 1),
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_unref(maxInputFormatted)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "facet-range-control__track",
        ref_key: "track",
        ref: track
      }, [
        _createElementVNode("div", {
          class: "facet-range-control__train",
          style: _normalizeStyle(_unref(trainStyle))
        }, null, 4),
        _createElementVNode("div", {
          class: "facet-range-control__handle",
          style: _normalizeStyle(_unref(minHandleStyle))
        }, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "facet-range-control__handle-click",
            onMousedown: _cache[0] || (_cache[0] = ($event: any) => (dragStart($event, 'min'))),
            onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (dragStart($event, 'min')))
          }, null, 32)
        ], 4),
        _createElementVNode("div", {
          class: "facet-range-control__handle",
          style: _normalizeStyle(_unref(maxHandleStyle))
        }, [
          _hoisted_6,
          _createElementVNode("div", {
            class: "facet-range-control__handle-click",
            onMousedown: _cache[2] || (_cache[2] = ($event: any) => (dragStart($event, 'max'))),
            onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (dragStart($event, 'max')))
          }, null, 32)
        ], 4)
      ], 512)
    ])
  ], 64))
}
}

})